import ReactLoader from './react_loader'

ReactLoader.registerComponents({
  Basket: require('../components/Basket/Basket')
})
